import React from "react";
import Button from "../../../../../shared/button/button";

const SalesFilterTag = props => {
	return (
		<div className="sales-filter-tag">
			{props.value}

			{!props.hiddenButtonClose && (
				<Button
					className="btn-gray-sm-icon sales-filter-tag--button-close"
					onClick={props.handleButtonClose}
					data-action="sales-filter-tag-close"
				>
					<i className="icon-close sales-filter-tag--button-close--icon" />
				</Button>
			)}
		</div>
	);
};

export default SalesFilterTag;
